import { render, staticRenderFns } from "./IframeTicket.vue?vue&type=template&id=1bdf367d"
import script from "./IframeTicket.vue?vue&type=script&lang=js"
export * from "./IframeTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports